export default "__VITE_ASSET__DLh1hcwb__"